import {
  AssetParams,
  Connections,
  ConnectionTestResult,
} from '@mss/mss-component-library';
import Fetch from '../../util/_fetch';

type TestConnectionParams = {
  index?: number;
  type?: keyof Connections;
  assetParams: Omit<AssetParams, 'category'>;
  body: Record<string, string | number | boolean>;
  method?: 'put' | 'post';
  jsonBody?: boolean;
  customKeyMapping?: Record<string, string>;
  isNew?: boolean;
  endpoint?: string;
};

export async function testConnection({
  body,
  assetParams,
  customKeyMapping,
}: TestConnectionParams): Promise<ConnectionTestResult['result']> {
  const apiAssetType =
    assetParams.assetType === 'network'
      ? assetParams.assetType
      : assetParams.assetSubType;


  const newBody = customKeyMapping
    ? Object.entries(body).reduce(
      (acc, [key, value]: [string, any]) => {
        return { ...acc, [customKeyMapping[key] || key]: value ?? '' };
      },
      {} as Record<string, any>
    )
    : body;

  const validBody = Object.fromEntries(
    Object.entries(newBody).filter(
      ([_, value]) =>
        value !== null && value !== undefined && value !== ''
    )
  );
  const response = await Fetch.post(
    `/api/core/asset-type/${apiAssetType}/connection-test/`,
    {
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      },
      body: JSON.stringify(validBody),
    }
  );

  const result = await response.json();

  if (!response.ok) {
    throw new Error(
      'Error with connection check: ' +
      response.status +
      ': ' +
      response.statusText,
      { cause: result } as ErrorOptions
    );
  }

  return {
    message: result.result_object
      ? JSON.stringify(result.result_object)
      : result.error,
    status: {
      account: result.account,
      port: result.port,
      query: result.query,
    },
  };
}
